<template>
    <LoadingBar ref="loadingBar" />

    <header class="fixed inset-x-0 top-0 z-[9999] w-full
               border-b border-slate-200/80 dark:border-slate-800/80
               bg-slate-50/95 text-slate-900
               backdrop-blur-md
               dark:bg-slate-950/95 dark:text-white">
        <nav class="container mx-auto flex min-h-[64px] items-center justify-between
                   px-3 sm:px-4 lg:px-6">

            <div class="flex min-w-0 items-center">

                <router-link :to="langPath" class="flex shrink-0 items-center
                           transition-opacity duration-200
                           hover:opacity-80">
                    <img src="@/assets/images/logo.png" class="h-9 w-9 sm:h-10 sm:w-10" alt="Logo" />

                    <img src="@/assets/images/text-logo.png"
                        class="ms-2 hidden h-auto w-36 object-contain md:block lg:w-44" alt="Binesheno" />
                </router-link>

                <div class="ms-5 hidden xl:flex items-center
                           rounded-2xl border border-slate-200/70
                           bg-white/40 p-1
                           dark:border-slate-800/70
                           dark:bg-slate-900/40">
                    <router-link :to="langPath" :class="navLinkClass('')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("home") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/library`" :class="navLinkClass('library')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("library") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/posts`" :class="navLinkClass('posts')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("posts") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/media`" :class="navLinkClass('media')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("media") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/sound`" :class="navLinkClass('sound')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("sound") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/photo`" :class="navLinkClass('photo')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("photo") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/aboutus`" :class="navLinkClass('aboutus')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 shrink-0">
                            <path
                                d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
                                fill="currentColor" />
                        </svg>

                        <span>{{ $t("about_us") }}</span>
                    </router-link>
                </div>
            </div>

            <div class="flex shrink-0 items-center gap-2 sm:gap-3">

                <div class="relative">
                    <button @click="toggleLangMenu" class="flex h-9 items-center gap-1.5 rounded-xl
                               px-2.5 text-sm font-medium
                               text-slate-700 transition
                               hover:bg-slate-200/70
                               dark:text-slate-200
                               dark:hover:bg-slate-800">
                        <span class="hidden sm:inline">
                            {{ $t("select_language") }}
                        </span>

                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="h-5 w-5" viewBox="0 0 16 16">
                            <path
                                d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z" />
                            <path
                                d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31" />
                        </svg>
                    </button>

                    <div v-show="langMenuOpen" class="absolute end-0 top-full mt-2 z-50
                               w-44 overflow-hidden rounded-xl
                               border border-slate-200
                               bg-white shadow-xl
                               dark:border-slate-700
                               dark:bg-slate-900">
                        <ul class="py-1.5 text-sm">
                            <li v-for="item in language" :key="item.id">
                                <a href="#" @click.prevent="setLanguage(item)" class="block px-4 py-2.5
                                           text-slate-700
                                           transition
                                           hover:bg-slate-100
                                           dark:text-slate-200
                                           dark:hover:bg-slate-800">
                                    {{ item.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="flex items-center" dir="ltr">
                    <label class="relative inline-flex cursor-pointer items-center">
                        <input type="checkbox" class="peer sr-only" @change="toggleDarkMode" ref="darkModeCheckbox" />

                        <div class="relative h-5 w-9 rounded-full
                                   bg-slate-300
                                   transition-colors
                                   after:absolute after:start-[2px]
                                   after:top-[2px]
                                   after:h-4 after:w-4
                                   after:rounded-full
                                   after:border after:border-slate-300
                                   after:bg-white
                                   after:transition-all
                                   peer-checked:bg-greenrefah
                                   peer-checked:after:translate-x-full
                                   peer-checked:after:border-white
                                   dark:bg-slate-700
                                   dark:border-slate-600"></div>
                    </label>
                </div>
            </div>
        </nav>
    </header>

    <main class="mt-[64px] min-h-[calc(100vh-64px)]
               bg-slate-50 text-slate-900
               dark:bg-slate-950 dark:text-white
               pb-24 xl:pb-0">
        <router-view v-slot="{ Component, route }">
            <component :is="Component" :key="$i18n.locale + '-' + route.fullPath" />
        </router-view>
    </main>

    <footer class="border-t border-slate-200
               bg-slate-50 text-slate-900
               dark:border-slate-800
               dark:bg-slate-950 dark:text-white">
        <div class="container mx-auto px-4 py-8 md:py-10">
            <div class="flex flex-col gap-6
                       sm:flex-row sm:items-center
                       sm:justify-between">
                <a href="https://binesheno.com/" class="flex items-center gap-3
                           transition-opacity hover:opacity-80">
                    <img src="@/assets/images/logo.png" class="h-9 w-9" alt="Binesheno" />

                    <span class="rounded-lg bg-primary px-3 py-1.5
                               text-sm font-medium text-white">
                        {{ $t("footer_institute") }}
                    </span>
                </a>

                <ul class="flex items-center text-sm
                           font-medium text-slate-500
                           dark:text-slate-400">
                    <li>
                        <router-link :to="`${langPath}/aboutus`" class="transition-colors hover:text-primary">
                            {{ $t("about_us") }}
                        </router-link>
                    </li>
                </ul>
            </div>

            <hr class="my-6 border-slate-200
                       dark:border-slate-800" />

            <span class="block text-center text-sm
                       text-slate-500
                       dark:text-slate-400">
                © 1404-1405

                <router-link :to="langPath" class="font-medium transition-colors hover:text-primary">
                    {{ $t("footer_institute") }}
                </router-link>.

                {{ $t("footer_rights") }}
            </span>
        </div>
    </footer>

    <button v-if="isVisible" @click="scrollToTop" class="fixed bottom-[82px] end-4 z-[9998]
               rounded-xl bg-primary
               px-3 py-2 text-xs font-medium
               text-white shadow-lg
               transition-all duration-200
               hover:-translate-y-0.5
               hover:shadow-xl
               xl:bottom-5" aria-label="Scroll to top">
        {{ $t("back_to_top") }}
    </button>

    <nav class="fixed inset-x-0 bottom-0 z-[9999]
               xl:hidden
               border-t border-slate-200/80
               bg-slate-50/95
               px-2 pb-[max(8px,env(safe-area-inset-bottom))]
               pt-2
               shadow-[0_-8px_30px_rgba(15,23,42,0.08)]
               backdrop-blur-xl
               dark:border-slate-800/80
               dark:bg-slate-950/95
               dark:shadow-[0_-8px_30px_rgba(0,0,0,0.25)]">
        <div class="mx-auto grid max-w-lg grid-cols-5
                   items-stretch gap-1">
            <router-link :to="langPath" :class="mobileNavLinkClass('')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5">
                    <path
                        d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
                        fill="currentColor" />
                </svg>

                <span>{{ $t("home") }}</span>
            </router-link>

            <router-link :to="`${langPath}/library`" :class="mobileNavLinkClass('library')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5">
                    <path
                        d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
                        fill="currentColor" />
                </svg>

                <span>{{ $t("library") }}</span>
            </router-link>


            <router-link :to="`${langPath}/posts`" :class="mobileNavLinkClass('posts')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5">
                    <path
                        d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
                        fill="currentColor" />
                </svg>

                <span>{{ $t("posts") }}</span>
            </router-link>

            <router-link :to="`${langPath}/media`" :class="mobileNavLinkClass('media')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5">
                    <path
                        d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                        fill="currentColor" />
                </svg>

                <span>{{ $t("media") }}</span>
            </router-link>

            <router-link :to="`${langPath}/aboutus`" :class="mobileNavLinkClass('aboutus')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5">
                    <path
                        d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
                        fill="currentColor" />
                </svg>

                <span>{{ $t("about_us") }}</span>
            </router-link>



        </div>
    </nav>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingBar from "@/components/LoadingBar.vue";

export default {
    name: "TheContainer",

    components: {
        LoadingBar,
    },

    data() {
        return {
            isVisible: false,
            langMenuOpen: false,
        };
    },

    computed: {
        ...mapGetters({
            language: "baseX/language",
        }),

        currentLang() {
            return this.$route.path.split("/")[1] || "fa";
        },

        langPath() {
            return `/${this.currentLang}`;
        },

        basePathWithoutLang() {
            return this.$route.path.replace(/^\/[^/]+/, "");
        },
    },

    watch: {
        $route() {
            if (this.$refs.loadingBar) {
                this.$refs.loadingBar.startLoading();

                setTimeout(() => {
                    this.$refs.loadingBar.stopLoading();
                }, 1000);
            }

            this.langMenuOpen = false;
        },
    },

    methods: {
        navLinkClass(path) {
            const current = this.$route.path;
            const target = path
                ? `${this.langPath}/${path}`
                : this.langPath;

            const active = current === target;

            return [
                "flex items-center gap-2 rounded-xl px-3 py-2",
                "text-sm font-bold whitespace-nowrap",
                "transition-all duration-200",
                active
                    ? "bg-primary text-white shadow-sm"
                    : "text-slate-700 hover:bg-slate-200/70 hover:text-primary dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-primary",
            ];
        },

        mobileNavLinkClass(path) {
            const current = this.$route.path;
            const target = path
                ? `${this.langPath}/${path}`
                : this.langPath;

            const active = current === target;

            return [
                "flex min-w-0 flex-col items-center justify-center",
                "gap-1 rounded-xl px-1 py-1.5",
                "text-[10px] sm:text-[11px] font-medium leading-tight",
                "transition-all duration-200",
                "select-none",
                active
                    ? "bg-primary/10 text-primary dark:bg-primary/15"
                    : "text-slate-500 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white",
            ];
        },

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },

        handleScroll() {
            this.isVisible = window.scrollY > 300;
        },

        toggleDarkMode(event) {
            const html = document.querySelector("html");

            if (event.target.checked) {
                html.classList.add("dark");
                localStorage.setItem("darkMode", "enabled");
            } else {
                html.classList.remove("dark");
                localStorage.setItem("darkMode", "disabled");
            }
        },

        toggleLangMenu() {
            this.langMenuOpen = !this.langMenuOpen;
        },

        setLanguage(item) {
            const newLang = item.codeKey;

            this.$i18n.locale = newLang;

            localStorage.setItem("languageCode", newLang);
            localStorage.setItem("languageId", item.id);

            const pathAfterLang = this.$route.path.replace(
                /^\/[^/]+/,
                ""
            );

            const newPath = `/${newLang}${pathAfterLang || ""}`;

            if (newPath !== this.$route.path) {
                this.$router.replace(newPath).catch(() => { });
            }

            this.langMenuOpen = false;
        },
    },

    mounted() {
        window.addEventListener("scroll", this.handleScroll);

        this.$store.dispatch("baseX/getLanguage");

        const darkMode = localStorage.getItem("darkMode");

        if (darkMode === "enabled") {
            document
                .querySelector("html")
                .classList.add("dark");

            if (this.$refs.darkModeCheckbox) {
                this.$refs.darkModeCheckbox.checked = true;
            }
        }

        const savedLang =
            localStorage.getItem("languageCode") || "fa";

        if (this.$i18n.locale !== savedLang) {
            this.$i18n.locale = savedLang;
        }
    },

    beforeUnmount() {
        window.removeEventListener(
            "scroll",
            this.handleScroll
        );
    },
};
</script>

<style scoped>
@media print {
    .noprint {
        display: none !important;
    }
}

nav a,
nav button {
    -webkit-tap-highlight-color: transparent;
}

@media (max-width: 639px) {
    nav a span {
        max-width: 58px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>